module.exports = __webpack_public_path__ + "img/3-min.33cfd9a5.jpg";